export const LonLat = (obj) => {
  if (obj?.Location) obj = obj.Location;
  return [
    obj.Lon ?? obj.Lng ?? obj.lng,
    obj.Lat ?? obj.lat
  ];
};